import { useState } from 'react';
import CustomTextAreaInput from '../../InputFields/CustomTextAreaInput';
import CustomTextInput from '../../InputFields/CustomTextInput';

const InformationDataType = ({
  onDataChange,
  isModal,
  errors,
  setErrors,
  informationContainerContent,
  modalContent,
  isPopulateData,
  tabName,
}: {
  onDataChange: (data: any) => void;
  isModal: boolean;
  errors: any;
  setErrors: any;
  informationContainerContent?: string;
  modalContent?: string;
  isPopulateData?: boolean;
  tabName?: string;
}) => {
  const [formData, setFormData] = useState({
    informationContainerContent: informationContainerContent || '',
    modalContent: modalContent || '',
    tabName: tabName || '',
  });

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };

    setFormData(updatedFormData);
    onDataChange(updatedFormData);
    setErrors((prevErrors: any) => ({
      ...prevErrors,
      informationContainerContent: '',
      modalContent: '',
    }));
  };

  return (
    <div className="ml-4">
      {!isModal ? (
        <CustomTextAreaInput
          label="Information Container Content"
          name="informationContainerContent"
          value={formData.informationContainerContent}
          onChange={handleInputChange}
          placeholder="Enter the information Container content. i.e - This section provides key points of contact for communication and support."
          description="This will display detailed information shown in the information container."
          error={errors.informationContainerContent}
          required
          maxLength={10000}
          rows={14}
        />
      ) : (
        <CustomTextAreaInput
          label="Modal Content"
          name="modalContent"
          value={formData.modalContent}
          onChange={handleInputChange}
          placeholder="Enter the modal content. i.e - This section provides key points of contact for communication and support."
          description="This will display detailed information shown in the modal."
          error={errors.modalContent}
          required
          maxLength={10000}
          rows={14}
        />
      )}

      {isPopulateData && (
        <div className="mt-4">
          <CustomTextInput
            label="Data Identifier Name"
            name="tabName"
            value={formData?.tabName}
            onChange={handleInputChange}
            error={errors.tabName}
            className="text-ds-gray-500 font-semibold text-sm"
            placeholder="Enter data identifier name"
          />
        </div>
      )}
    </div>
  );
};

export default InformationDataType;
